import React, { useState, useEffect } from 'react'
import {
  Row,
  Col,
  Form,
  Input,
  Select,
  Button,
  Table,
  Modal,
  InputNumber,
  notification,
} from 'antd'

import styled from 'styled-components'
import ColorList from 'constants/color.constants'
import { SearchOutlined } from '@ant-design/icons'

import { getCookie } from 'helper/cookie'

import {
  getResultKPIFinance,
  addKPIFinance,
  goalKPIFinance,
  cleanKpi,
} from 'api/Project/kpifinance'
import { useForm } from 'antd/lib/form/Form'

import lang from 'lang/en'
import { Item } from 'gg-editor'
import { InboxOutlined, LockOutlined } from '@ant-design/icons'

const Container = styled.div`
  background-color: ${ColorList.white};

  width: 100;
  height: auto;
  margin-top: 16px;
  margin-left: 4px;
`

const initalState = {
  data: [],
  isLoading: true,
}

const NoPermissionSupportNeed = (props) => {
  // console.log(props)
  const {
    idEditPRJ,
    visableModalTaskGoals,
    setVisableModalTaskGoals,
    data,
    getResultKpi,
    idtask,
    type,
  } = props

  // ant-row ant-form-item ant-form-item-has-success
  return (
    <div
      className="emytystatesprinttaskflow"
      style={{
        minHeight: '65vh',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <LockOutlined className="inbox" />
      <p style={{ fontSize: 20, fontWeight: 'bold', marginTop: 21 }}>No Permission</p>
    </div>
  )
}
export default NoPermissionSupportNeed
